var React = require('react');

function Back (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor"},React.createElement("path",{"d":"M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"})));
}

Back.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Back;

Back.default = Back;
